import { createSlice } from "@reduxjs/toolkit"
import { createUser, retrieveAllScopes, retrieveProfile, retrieveUser, retrieveUsers, updateUser } from "./UserAction"
import { Scope, User } from "./interfaces"

interface UserState {
  user: User
  userList: User[]
  totalRecords: Number | undefined
  scopes: Scope[]
}

const initialState = {
  user: {} as User,
  userList: [],
  totalRecords: undefined,
  scopes: []
} as UserState

const userSlicer = createSlice({
  name: 'user',
  initialState,
  reducers: {
    reset: (state: UserState) => {
      state.user = {} as User
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(retrieveUsers.fulfilled, (state: any, { payload }) => {
        state.userList = payload.content
        state.totalRecords = Number(payload.totalElements)
      })
      .addCase(retrieveUser.fulfilled, (state: any, { payload }) => {
        state.user = payload
      })
      .addCase(retrieveProfile.fulfilled, (state: any, { payload }) => {
        state.user = payload
      })
      .addCase(retrieveAllScopes.fulfilled, (state: any, { payload }) => {
        state.scopes = payload
      })
      .addCase(createUser.fulfilled, (state: any, { payload }) => {
        state.user = payload
      })
      .addCase(updateUser.fulfilled, (state: any, { payload }) => {
        state.user = payload
      })
  },
})

export const { reset } = userSlicer.actions;
export default userSlicer.reducer